import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullFrequency',
  standalone: false
})
export class InvestmentsFrequencyPipe implements PipeTransform {
  public transform(weeksBetweenInvestments: 1 | 4 | 12): string {
    switch (weeksBetweenInvestments) {
      case 1:
        return 'weekly';
      case 4:
        return 'monthly';
      case 12:
        return 'quarterly';
      default:
        throw new Error('Unsupported frequency period: ' + weeksBetweenInvestments);
    }
  }
}